var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"stored-how object-store-help-on-hover",attrs:{"title":_setup.title}},[_vm._v(_vm._s(_setup.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }